<template>
    <div class="col-md-12">
        <br />
        <form name="newDocument"
              class="form-horizontal form-label-left"
              @submit.prevent="handleSubmit()">
            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">LastName :</label>
                <div class="col-md-6 col-sm-6">
                    <input name="LastName"
                           v-validate="'max:255'"
                           v-model="encodingData.LastName"
                           class="form-control" 
                           :class="{ 'is-invalid': submitted && errors.has('LastName') }" />
                    <div v-if="submitted && errors.has('LastName')"
                         class="invalid-feedback">
                        {{ errors.first("LastName") }}
                    </div>
                </div>
            </div>
            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">Suffix (Jr, IV) :</label>
                <div class="col-md-6 col-sm-6">
                    <input name="NameSuffix"
                           v-validate="'max:50'"
                           v-model="encodingData.NameSuffix"
                           class="form-control"
                           :class="{ 'is-invalid': submitted && errors.has('NameSuffix') }" />
                    <div v-if="submitted && errors.has('NameSuffix')"
                         class="invalid-feedback">
                        {{ errors.first("NameSuffix") }}
                    </div>
                </div>
            </div>

            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">FirstName :</label>
                <div class="col-md-6 col-sm-6">
                    <input name="FirstName"
                           v-validate="'max:255'"
                           v-model="encodingData.FirstName"
                           class="form-control"
                           :class="{ 'is-invalid': submitted && errors.has('FirstName') }" />
                    <div v-if="submitted && errors.has('FirstName')"
                         class="invalid-feedback">
                        {{ errors.first("FirstName") }}
                    </div>
                </div>
            </div>

            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">MiddleName :</label>
                <div class="col-md-6 col-sm-6">
                    <input name="MiddleName"
                           v-validate="'max:255'"
                           v-model="encodingData.MiddleName"
                           class="form-control"
                           :class="{ 'is-invalid': submitted && errors.has('MiddleName') }" />
                    <div v-if="submitted && errors.has('MiddleName')"
                         class="invalid-feedback">
                        {{ errors.first("MiddleName") }}
                    </div>
                </div>
            </div>

            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">Alias :</label>
                <div class="col-md-6 col-sm-6">
                    <input name="Alias"
                           v-validate="'max:200'"
                           v-model="encodingData.Alias"
                           class="form-control"
                           :class="{ 'is-invalid': submitted && errors.has('Alias') }" />
                    <div v-if="submitted && errors.has('Alias')"
                         class="invalid-feedback">
                        {{ errors.first("Alias") }}
                    </div>
                </div>
            </div>

            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">Birth Country:</label>
                <div class="col-md-6 col-sm-6">
                    <select name="SourceId"
                            v-model="encodingData.BirthCountry"
                            class="form-control">
                        <option value>Select Birth Country</option>
                        <option v-for="option in countries"
                                v-bind:value="option.countryName"
                                v-bind:key="option.countryName">
                            {{ option.countryName }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">Nationality:</label>
                <div class="col-md-6 col-sm-6">
                    <select name="SourceId"
                            v-model="encodingData.Nationality"
                            class="form-control">
                        <option value="">Select Nationality</option>
                        <option v-for="option in countries"
                                v-bind:value="option.countryName"
                                v-bind:key="option.countryName">
                            {{ option.countryName }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">BirthState:</label>
                <div class="col-md-6 col-sm-6">
                    <select name="SourceId"
                            v-model="encodingData.BirthState"
                            class="form-control">
                        <option value>Select Birth State</option>
                        <option v-for="option in provinces"
                                v-bind:value="option.province"
                                v-bind:key="option.province">
                            {{ option.province }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">BirthDate :</label>
                <div class="col-md-6 col-sm-6">
                    <input type="date"
                           name="BirthDate"
                           v-model="encodingData.BirthDate"
                           class="form-control" />
                </div>
            </div>
            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">BirthCity :</label>
                <div class="col-md-6 col-sm-6">
                    <input type="text"
                           v-validate="'max:50'"
                           name="BirthCity"
                           v-model="encodingData.BirthCity"
                           class="form-control"
                           :class="{ 'is-invalid': submitted && errors.has('BirthCity') }" />
          <div v-if="submitted && errors.has('BirthCity')"
                class="invalid-feedback">{{ errors.first("BirthCity") }}</div>
                </div>
            </div>

            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">Religion :</label>
                <div class="col-md-6 col-sm-6">
                    <select name="SourceId"
                            v-model="encodingData.Religion"
                            class="form-control">
                        <option value>Select Religion</option>
                        <option value="Catholic">Catholic</option>
                        <option value="Islam">Islam</option>
                        <option value="Protestant">Protestant</option>
                        <option value="Buddhism">Buddhism</option>
                        <option value="Shintoism">Shintoism</option>
                        <option value="Iglesia Ni Cristo">Iglesia Ni Cristo</option>
                    </select>
                </div>
            </div>
            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">Gender :</label>
                <div class="col-md-6 col-sm-6">
                    <select name v-model="encodingData.Sex" class="form-control">
                        <option value>Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                    </select>
                </div>
            </div>

            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">Status :</label>
                <div class="col-md-6 col-sm-6">
                    <select name v-model="encodingData.Status" class="form-control">
                        <option value>Select Status</option>
                        <option value="Single">Single</option>
                        <option value="Married">Married</option>
                        <option value="Separated">Separated</option>
                        <option value="Widowed">Widowed</option>
                    </select>
                </div>
            </div>
            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">Comments :</label>
                <div class="col-md-6 col-sm-6">
                    <textarea name="Comments"
                              v-model="encodingData.Comments"
                              class="form-control"
                              cols="5"
                              rows="5" />
                </div>
            </div>

            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">PersonalData :</label>
                <div class="col-md-6 col-sm-6">
                    <textarea name="PersonalData"
                              v-model="encodingData.PersonalData"
                              class="form-control"
                              cols="5"
                              rows="5" />
                </div>
            </div>

            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">PhysicalDescription :</label>
                <div class="col-md-6 col-sm-6">
                    <textarea name="PhysicalDescription"
                              v-model="encodingData.PhysicalDescription"
                              class="form-control"
                              cols="5"
                              rows="5" />
                </div>
            </div>

            <div class="ln_solid"></div>
            <div class="item form-group">
                <div class="col-md-6 col-sm-6">
                    <button type="submit" class="btn btn-primary">Save</button>&nbsp;
                    <button type="button" v-on:click="clearControls()" class="btn btn-primary">Clear</button>
                </div>
            </div>
        </form>
        <b-modal id="LinkPopPN" title="Link Builder" scrollable hide-footer>
            <LinkPopUp />
        </b-modal>
    </div>
</template>

<script>
    import {
        authHeader,
        responseCheck,
        notifyHelper,
        EncodeURL,
        checkLinkMode,
        getlocalstorageCountry,
        getlocalstorageProvince,
        setObject2Link,
    } from "../../helper";
    import LinkPopUp from "../master/Linking";
    import instance from "../../helper/http";
    export default {
        data() {
            return {
                encodingData: {
                    LastName: "",
                    NameSuffix: "",
                    FirstName: "",
                    MiddleName: "",
                    Alias: "",
                    BirthCountry: "",
                    Nationality: "",
                    BirthState: "",
                    BirthDate: null,
                    BirthCity: "",
                    Religion: "",
                    Sex: "",
                    Status: "",
                    Comments: "",
                    PersonalData: "",
                    PhysicalDescription: "",
                },
                countries: [],
                provinces: [],
            };
        },
        components: {
            LinkPopUp,
        },
        methods: {
            handleSubmit() {
                let loader = this.$loading.show();
                instance
                    .post(EncodeURL + "newperson", this.encodingData, {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        if (response.data.error) {
                            loader.hide();
                            notifyHelper(
                                "error",
                                "There was an error processing your request!"
                            );
                        } else {
                            notifyHelper("success", "Saved");
                            //this.clearControls()
                            loader.hide();
                            if (checkLinkMode()) {
                                if (confirm("Link this newly created entity?")) {
                                    setObject2Link(response.data.id, "PN");
                                    this.setLink(response.data.id);
                                }
                            }
                        }
                    })
                    .catch(function (error) {
                        loader.hide();
                        responseCheck(error.response.status);
                    });
            },
            getlibs() {
                this.countries = getlocalstorageCountry();
                this.provinces = getlocalstorageProvince();
            },
            setLink: function (id) {
                setObject2Link(id, "PN");
                this.$bvModal.show("LinkPopPN");
            },
            clearControls() {
                this.encodingData.LastName = "";
                this.encodingData.FirstName = "";
                this.encodingData.MiddleName = "";
                this.encodingData.Alias = "";
                this.encodingData.NameSuffix = "";
                this.encodingData.BirthCountry = "";
                this.encodingData.Nationality = "";
                this.encodingData.BirthState = "";
                this.encodingData.BirthDate = null;
                this.encodingData.BirthCity = "";
                this.encodingData.Religion = "";
                this.encodingData.Sex = "";
                this.encodingData.Status = "";
                this.encodingData.Comments = "";
                this.encodingData.PersonalData = "";
                this.encodingData.PhysicalDescription = "";
            },
        },
        created: function () {
            this.getlibs();
        },
    };
</script>
